export default {
    YES: 'Da',
    NO: 'Ne',
    OK: 'OK',
    CANCEL: 'Otkaži',
    CLOSE: 'Zatvori',
    CONFIRM: 'Potvrdi',
    CONFIRM_DELETE: 'Da li ste sigurni da želite da obrišete ovu stavku?',
    DROP_ZONE_1: 'Klikni za upload',
    DROP_ZONE_2: 'ili prevuci',
    DROP: 'Pusti fajl',
    DROP_ZONE_FILE_TYPES: 'SVG, PNG, JPG, JPEG, WEBP',
    ACTIONS: 'Akcije',
    UNLIMITED: 'NEOGRANIČENO',
    BACK: 'Nazad',
    MISSING_PLACE: 'Nedostaje lokal',
};
